var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.523,
    height: 45.411,
    viewBox: "0 0 74.523 45.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_558",
    "data-name": "Groupe 558",
    transform: "translate(-184.862 -3506.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M1.443,13.158v0A16.59,16.59,0,1,1,8.488,30.438l-.033.028c-5.958,5.04,5.138,12.916,5.138,12.916a18.243,18.243,0,0,0-2.323,2.029C-5.474,38.558,1.376,13.4,1.443,13.158Z",
    transform: "translate(184.862 3506.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M1.443,13.158v0A16.59,16.59,0,1,1,8.488,30.438l-.033.028c-5.958,5.04,5.138,12.916,5.138,12.916a18.243,18.243,0,0,0-2.323,2.029C-5.474,38.558,1.376,13.4,1.443,13.158Z",
    transform: "translate(225.091 3506.457)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote1);
export default __webpack_public_path__ + "static/media/quote1.06736fb459521cb584199a5e7b60721b.svg";
export { ForwardRef as ReactComponent };